import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "./components/layout/Layout";

// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import CV from "./pages/CV";
import InTheNews from "./pages/InTheNews";
import Videos from "./pages/Videos";
import VideoDetail from "./pages/VideoDetail";
import Awards from "./pages/Awards";
import Books from "./pages/Books";
import BookDetail from "./pages/BookDetail";
import Topics from "./pages/Topics";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Speaking from "./pages/Speaking";
import Consulting from "./pages/Consulting";
import Advisory from "./pages/Advisory";
import Contact from "./pages/Contact";
import Marketplace from "./pages/Marketplace";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/cv" element={<CV />} />
            <Route path="/news" element={<InTheNews />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/videos/:slug" element={<VideoDetail />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/books" element={<Books />} />
            <Route path="/books/:slug" element={<BookDetail />} />
            <Route path="/topics" element={<Topics />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/speaking" element={<Speaking />} />
            <Route path="/consulting" element={<Consulting />} />
            <Route path="/advisory" element={<Advisory />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
